module.exports = "/assets/data/71768700620a7c374465cd813db6f032-LE12.data.json";